import { Api } from '@ori/static-api-client';
const clients = new Map();
export function createStaticApiClient({
  baseUrl
}) {
  if (clients.has(baseUrl)) {
    return clients.get(baseUrl);
  }
  const client = new Api({
    baseUri: baseUrl
  });
  clients.set(baseUrl, client);
  return client;
}
//# sourceMappingURL=createStaticApiClient.js.map